import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';
import { pathForGoTo } from '../lib/siteRoutes';

export default function PracticesPage() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const go = (page) => navigate(pathForGoTo(page));

  const tagStyleLight = { fontSize: '11px', padding: '3px 10px', border: '1px solid rgba(201,168,76,0.35)', color: 'var(--gold)' };
  const tagStyleSolid = { fontSize: '11px', padding: '3px 10px', border: '1px solid var(--gold)', color: 'var(--gold)' };
  const cards = [
    {
      page: 'pa-corporate',
      num: '01',
      name: t('home.practiceCards.corporate.name'),
      desc: t('home.practiceCards.corporate.desc'),
      tags: ['M&A', 'FDI', t('practices.tags.chambersRanked')],
      solidTagIndex: 2,
    },
    {
      page: 'pa-licensing',
      num: '02',
      name: t('home.practiceCards.licensing.name'),
      desc: t('home.practiceCards.licensing.desc'),
      tags: [t('practices.tags.compliance'), t('practices.tags.licensing'), t('practices.tags.government')],
    },
    {
      page: 'pa-labour',
      num: '03',
      name: t('home.practiceCards.labour.name'),
      desc: t('home.practiceCards.labour.desc'),
      tags: [t('practices.tags.laborCode'), t('practices.tags.workPermits'), t('practices.tags.chambersRanked')],
      solidTagIndex: 2,
    },
    {
      page: 'pa-privacy',
      num: '04',
      name: t('home.practiceCards.privacy.name'),
      desc: t('home.practiceCards.privacy.desc'),
      tags: [t('practices.tags.decree13'), t('practices.tags.dpia'), t('practices.tags.dpo')],
    },
    {
      page: 'pa-realestate',
      num: '05',
      name: t('home.practiceCards.realestate.name'),
      desc: t('home.practiceCards.realestate.desc'),
      tags: [t('practices.tags.landLaw2024'), t('practices.tags.industrialZones'), t('practices.tags.hotels')],
    },
    {
      page: 'pa-disputes',
      num: '06',
      name: t('home.practiceCards.disputes.name'),
      desc: t('home.practiceCards.disputes.desc'),
      tags: [t('practices.tags.viac'), t('practices.tags.litigation'), t('practices.tags.arbitration')],
    },
  ];
  const industryKeys = [
    'garments', 'pharma', 'automotive', 'furniture', 'fmcg', 'insurance',
    'software', 'logistics', 'realestate', 'industrial', 'fintech', 'healthcare',
  ];

  return (
    <div id="page-practices" className="page">

      <section className="page-hero">
        <div className="hero-bg"></div>
        <div className="hero-inner">
          <div className="hero-eyebrow"><div className="eyebrow-line"></div><span className="eyebrow-text">{t('practices.eyebrow')}</span></div>
          <h1 className="page-hero-title">{t('practices.titleFirst')} <em>{t('practices.titleEm')}</em></h1>
          <p className="page-hero-sub">{t('practices.subtitle')}</p>
        </div>
      </section>

      <section className="section">
        <div className="practice-grid">
          {cards.map((card) => (
            <div key={card.page} className="practice-card" onClick={() => go(card.page)}>
              <div className="practice-number">{card.num}</div>
              <div className="practice-name">{card.name}</div>
              <p className="practice-desc">{card.desc}</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '20px' }}>
                {card.tags.map((tag, idx) => (
                  <span key={`${card.page}-${tag}-${idx}`} style={idx === card.solidTagIndex ? tagStyleSolid : tagStyleLight}>
                    {tag}
                  </span>
                ))}
              </div>
              <button className="practice-link" onClick={(e) => { e.stopPropagation(); go(card.page); }}>
                {t('practices.viewPractice')}
              </button>
            </div>
          ))}

        </div>
      </section>

      <section className="section section-alt">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '28px', height: '1px', background: 'var(--gold)' }}></div>
          <span style={{ fontSize: '10px', letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 500, fontFamily: 'var(--sans)' }}>{t('practices.sectors')}</span>
        </div>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(28px,3.5vw,44px)', fontWeight: 400, color: 'var(--navy)', marginBottom: '32px' }}>
          {t('practices.industriesWe')} <em style={{ fontStyle: 'italic', color: 'var(--gold)' }}>{t('practices.industriesServe')}</em>
        </h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {industryKeys.map((key) => (
            <div key={key} className="industry-tag">{t(`home.industries.${key}`)}</div>
          ))}
        </div>
      </section>

      <div className="pap-cta-band">
        <div>
          <h2>{t('practices.ctaTitle')}<br /><em>{t('practices.ctaTitleEm')}</em></h2>
          <p>{t('practices.ctaSub')}</p>
        </div>
        <div className="pap-cta-btns">
          <button className="btn-gold2" onClick={() => go('contact')}>{t('practices.contactUs')}</button>
          <button className="btn-outline" onClick={() => go('team')}>{t('practices.meetTeam')}</button>
        </div>
      </div>

      <Footer variant="full" firmColumn="team" />

    </div>
  );
}
